import { CanActivateFn, CanMatchFn } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { AuthNavigationService } from '../app/services/auth-navigation.service';

export const guestOnlyCanMatch: CanMatchFn = () => {
  const navigationService = inject(AuthNavigationService);
  return navigationService
    .ensurePrivate$()
    .pipe(
      map((privateMode) =>
        privateMode ? navigationService.getUrlToRedirect('/') : true
      )
    );
};

export const guestOnlyCanActivate: CanActivateFn = () => {
  const navigationService = inject(AuthNavigationService);
  return navigationService
    .ensurePrivate$()
    .pipe(
      map((privateMode) =>
        privateMode ? navigationService.getUrlToRedirect('/') : true
      )
    );
};
